export const generateSquareEndpoint = (path: string) => {
    const stage = process.env.REACT_APP_STAGE;
    const prefix = stage === 'prod' ? '' : `${stage}-`;
    return `https://${prefix}square.yllo.uk/api/v1/${path}`;
};
